const es = {
    '/': {
        title: '{brand} y Apuestas Deportivas | Retiros Rápidos',
        description: '{brand} y casa de apuestas en una sola cartera. Tragamonedas, casino en vivo y apuestas deportivas con retiros cripto al instante.',
        keywords: 'casino crypto, casino bitcoin, apuestas deportivas cripto, tragamonedas cripto, retiros instantáneos, casino provably fair'
    },
    '/casino': {
        title: '{brand} Casino en Línea | Slots, Blackjack & Dealers en Vivo',
        description: 'Tragamonedas, blackjack, ruleta & dealers en vivo en {brand}. Cientos de juegos, depósitos crypto rápidos & retiros instantáneos disponibles 24/7.',
        keywords: 'casino crypto, juegos de casino bitcoin, casino en línea, tragamonedas cripto, casino en vivo, blackjack, ruleta'
    },
    '/sports': {
        title: '{brand} Apuestas Deportivas | Cuotas, En Vivo & Crypto',
        description: 'Apuesta en deportes en {brand}. Cuotas competitivas en fútbol, baloncesto & más. Apuestas en vivo, apuestas crypto seguras & pagos rápidos.',
        keywords: 'apuestas deportivas cripto, casa de apuestas bitcoin, apuestas en vivo, cuotas de fútbol, apuestas esports'
    },
    '/livecasino': {
        title: '{brand} Casino en Vivo | Blackjack, Ruleta & Dealers Reales',
        description: 'Blackjack, ruleta & juegos de casino en vivo en {brand}. Dealers reales, streaming en HD & una amplia selección de mesas disponibles 24/7.',
        keywords: 'casino en vivo, dealers en vivo, blackjack en vivo, ruleta en vivo, baccarat en vivo, game shows'
    },
    '/slots': {
        title: '{brand} Tragamonedas Online | Demos Gratis, RTP & Max Win',
        description: 'Una enorme colección de tragamonedas en {brand}. Máquinas clásicas, video slots & progresivas, todas jugables con crypto.',
        keywords: 'tragamonedas cripto, tragaperras bitcoin, slots online, video slots, megaways, compra de bonus'
    },
    '/vip': {
        title: '{brand} Programa VIP | Recompensas Exclusivas y Beneficios',
        description: 'El programa VIP de {brand}: recompensas exclusivas, bonificaciones personalizadas y soporte prioritario. Beneficios diseñados para jugadores leales.',
        keywords: 'programa vip casino, rakeback, recompensas de fidelidad, casino high roller, niveles vip'
    },
    '/welcome-offer': {
        title: '{brand} Bono de Bienvenida | Casino Crypto',
        description: 'Descubre el bono de bienvenida de {brand}. Empieza con crypto y disfruta de beneficios exclusivos para nuevos jugadores.',
        keywords: 'bono de bienvenida casino, bono casino cripto, bono primer depósito, oferta nuevos jugadores'
    },
    '/referral': {
        title: '{brand} Programa de Referidos | Gana Recompensas',
        description: 'Invita amigos a {brand} y gana recompensas cuando se unan y cumplan los requisitos. Comparte tu enlace y comienza a ganar.',
        keywords: 'programa de referidos casino, bono por invitar amigos, recompensas de afiliados'
    },
    '/promotion-page': {
        title: '{brand} Promociones | Bonos y Ofertas Especiales',
        description: 'Explora todas las promociones activas en {brand}. Bonos, giros gratis y ofertas especiales para jugadores crypto.',
        keywords: 'promociones de casino, bonos casino cripto, carrera semanal, torneos de casino'
    },
    '/hotslots': {
        title: '{brand} Slots Populares | Tragamonedas Más Jugadas',
        description: 'Juega las tragamonedas más populares en {brand}. Los slots más calientes disponibles con crypto.'
    },
    '/newgames': {
        title: '{brand} Juegos Nuevos | Últimos Juegos de Casino',
        description: 'Descubre los últimos juegos de casino en {brand}. Nuevas tragamonedas, juegos en vivo y más, actualizado regularmente.'
    },
    '/populargames': {
        title: '{brand} Juegos Populares | Los Más Jugados en el Casino',
        description: 'Los juegos de casino más populares en {brand}. Desde tragamonedas hasta dealers en vivo, todos jugables con crypto.'
    },
    '/gameshows': {
        title: '{brand} Game Shows | Casino con Shows en Vivo',
        description: 'Disfruta los mejores game shows en vivo en {brand}. Presentadores reales, juegos únicos y grandes premios en tiempo real.'
    },
    '/table_games': {
        title: '{brand} Juegos de Mesa | Blackjack, Ruleta & Baccarat',
        description: 'Juega blackjack, ruleta, baccarat y más juegos de mesa en {brand}. Todo disponible con crypto.'
    },
    '/hotlive': {
        title: '{brand} Casino en Vivo Popular | Juegos en Vivo Más Jugados',
        description: 'Los juegos de casino en vivo más populares en {brand}. Juega con dealers reales en tiempo real.'
    },
    '/featurebuyin': {
        title: '{brand} Slots con Compra de Bonus | Feature Buy-in',
        description: 'Juega tragamonedas con opción de comprar el bonus en {brand}. Accede directamente al bonus round sin esperar.'
    },
    '/originals': {
        title: '{brand} Juegos de Casino Originales | Títulos Exclusivos',
        description: 'Juega juegos originales exclusivos en {brand}. Títulos únicos que no encontrarás en ningún otro lugar, desarrollados internamente para una experiencia de casino incomparable.'
    },
    '/providers': {
        title: '{brand} Proveedores de Juegos | Estudios Asociados & Software',
        description: 'Explora todos los proveedores de juegos en {brand}. Nos asociamos con los mejores estudios para ofrecerte una biblioteca crypto de alta calidad y gran variedad.'
    },
    '/about-us': {
        title: 'Sobre Nosotros | Conoce más sobre {brand}',
        description: 'Conoce {brand}, un casino crypto & sportsbook líder. Comprometidos con el juego seguro, justo & emocionante con retiros instantáneos en crypto.'
    },
    '/affiliate': {
        title: 'Programa de Afiliados | Gana Crypto con {brand}',
        description: 'Asóciate con {brand} & gana comisiones promocionando nuestro casino crypto. Tarifas competitivas, seguimiento en tiempo real & soporte dedicado para afiliados.'
    },
    '/faq': {
        title: '{brand} FAQ | Preguntas Frecuentes',
        description: 'Encuentra respuestas a preguntas frecuentes sobre {brand}. Consulta nuestras FAQ sobre cuentas, pagos, bonos & juegos de casino.'
    },
    '/aml-policy': {
        title: 'Política AML | Prevención de Lavado de Dinero en {brand}',
        description: 'La política AML de {brand} garantiza un entorno seguro y confiable. Conoce nuestras medidas para prevenir actividades ilícitas en nuestra plataforma.'
    },
    '/bonus-terms': {
        title: 'Términos y Condiciones de Bonos | Promociones de {brand}',
        description: 'Lee las reglas de bonos & promociones de {brand}. Aprende cómo reclamar, usar & retirar ganancias de bonos en nuestra plataforma.'
    },
    '/complaints-and-arbitration': {
        title: 'Quejas y Arbitraje | Soporte para Jugadores en {brand}',
        description: 'Conoce el proceso de resolución de quejas & disputas de {brand}. Garantizamos un trato justo y resolvemos los problemas de los jugadores de forma rápida y transparente.'
    },
    '/fairness': {
        title: 'Juegos Provably Fair | Garantía de Equidad en {brand}',
        description: '{brand} utiliza tecnología demostrablemente justa para garantizar que cada resultado sea verificable, transparente & completamente aleatorio.'
    },
    '/kyc-policy': {
        title: 'Política KYC | Verificación de Identidad en {brand}',
        description: 'La política KYC de {brand} describe nuestro proceso de verificación de identidad. Descubre cómo protegemos a los jugadores y mantenemos un entorno de juego seguro.'
    },
    '/payment-policy': {
        title: '{brand} Política de Pagos | Depósitos & Retiros en Crypto',
        description: '{brand} acepta depósitos & retiros en crypto. Lee nuestra política de pagos para conocer límites, monedas aceptadas & tiempos de procesamiento.'
    },
    '/privacy-policy': {
        title: 'Política de Privacidad | Protección de Datos en {brand}',
        description: 'La política de privacidad de {brand}. Descubre cómo recopilamos, usamos & protegemos tus datos personales en nuestra plataforma de casino crypto.'
    },
    '/responsible-gaming': {
        title: 'Juego Responsable | Juega de Forma Segura en {brand}',
        description: '{brand} está comprometido con el juego responsable. Accede a herramientas & recursos para gestionar tus hábitos de juego y jugar de forma segura.'
    },
    '/terms-of-service': {
        title: 'Términos de Servicio | {brand}',
        description: 'Revisa los términos & condiciones que rigen el uso de {brand}. Comprende tus derechos y responsabilidades como jugador.'
    },
    '/terms-sports': {
        title: 'Términos y Condiciones de Apuestas Deportivas | {brand}',
        description: 'Los términos & condiciones de apuestas deportivas de {brand}. Reglas para realizar apuestas, cobrar ganancias & usar el sportsbook en nuestra plataforma.'
    },
    '/special-bets': {
        title: '{brand} Apuestas especiales | Casa de apuestas cripto',
        description: 'Haga apuestas especiales en {brand}. Mercados de deportes, esports & eventos puntuales, con depósitos cripto instantáneos y pagos rápidos.'
    },
    '/transparency': {
        title: '{brand} Transparencia | Casino cripto demostrablemente justo',
        description: 'Vea cómo opera {brand} de forma abierta. Verificación de equidad demostrable, tasas de retorno publicadas desde el catálogo en vivo & pagos en cadena.'
    },
    '/faq/about': {
        title: 'Sobre {brand} | Preguntas frecuentes',
        description: 'Sobre {brand}: licencia, cómo funciona el casino cripto & qué hace justa la plataforma. Respuestas a las preguntas más comunes.'
    },
    '/faq/account': {
        title: '{brand} Cuenta | Preguntas frecuentes',
        description: 'Gestione su cuenta de {brand}: registro, inicio de sesión, verificación & ajustes de perfil. Respuestas a las dudas más comunes sobre la cuenta.'
    },
    '/faq/bonuses': {
        title: '{brand} Bonos | Preguntas frecuentes',
        description: 'Los bonos de {brand} explicados: ofertas de bienvenida, códigos promocionales, requisitos de apuesta & recompensas. Dudas frecuentes resueltas.'
    },
    '/faq/deposits': {
        title: '{brand} Depósitos | Preguntas frecuentes',
        description: 'Cómo depositar cripto en {brand}: monedas admitidas, redes, mínimos & tiempos de confirmación. Dudas frecuentes sobre depósitos resueltas.'
    },
    '/faq/games-sports': {
        title: '{brand} Juegos & deportes | Preguntas frecuentes',
        description: 'Juegos de casino & apuestas deportivas en {brand}: proveedores, equidad demostrable, cuotas & apuestas en directo. Dudas frecuentes resueltas.'
    },
    '/faq/responsible-gambling': {
        title: '{brand} Juego responsable | Preguntas frecuentes',
        description: 'Juego responsable en {brand}: límites de depósito, autoexclusión, pausas & herramientas de apoyo para jugar con seguridad.'
    },
    '/faq/security': {
        title: '{brand} Seguridad | Preguntas frecuentes',
        description: 'Seguridad en {brand}: protección de la cuenta, autenticación en dos pasos, equidad & privacidad de datos. Dudas frecuentes resueltas.'
    },
    '/faq/support-disputes': {
        title: '{brand} Soporte & reclamaciones | Preguntas frecuentes',
        description: 'Cómo obtener ayuda en {brand}: chat en vivo, tiempos de respuesta & cómo se resuelven las reclamaciones. Dudas frecuentes resueltas.'
    },
    '/faq/withdrawals': {
        title: '{brand} Retiros | Preguntas frecuentes',
        description: 'Cómo retirar cripto de {brand}: tiempos de pago, mínimos, comisiones & límites. Respuestas a las dudas más comunes sobre retiros.'
    }
};
export default es;
